import * as React from 'react';
import VerifyMail from '../../components/VerifyMail/VerifyMail';
import withData from '../../../../../boilerplate/redux/hocs/withData';
import LoadingIndicator from '../../../../components/Layout/LoadingIndicator/LoadingIndicator';
import { IWithDataProps } from '../../../../../boilerplate/redux/types/IWithDataProps';
import GenericErrorMap from '../../../../components/Layout/GenericErrorMap/GenericErrorMap';
import serverErrorMap from '../../components/VerifyMail/serverErrorMap';

interface IVerifyMailContainerProps {
    mail: string,
    token: string,
}

class VerifyMailContainerInner extends React.Component<IVerifyMailContainerProps & IWithDataProps> {

	public render () {
		return (
			<VerifyMail />
		)
	}
}

export default function VerifyMailContainer (theProps: IVerifyMailContainerProps) {
	const props = Object.assign({

	}, theProps);

	const RenderComponent = withData(
		VerifyMailContainerInner,
		'verifyMailReducer',
		`verifyMail`,
		{
            email: props.mail,
            verificationToken: props.token,
        },
        {
	        ErrorComponent: (errorProps: any) => (
		        <GenericErrorMap error={errorProps} serverErrorMap={serverErrorMap}/>
	        ),
	        LoadingComponent: (errorProps: any) => (
		        <LoadingIndicator>
					Daten werden geprüft ...
		        </LoadingIndicator>
	        ),
        }
        
	);

	return <RenderComponent {...props} />;
}


